import React, { useEffect } from 'react'
import { RcFile } from 'antd/lib/upload';
import classnames from 'classnames';
import moment from 'moment';

import { requiredValidation, emailValidation, identity } from 'utils';
import { ADGMLicenseProps } from 'types/addDetails';
import { Input, RenderIf } from 'components/components';
import { getTechnicalLicenseFile } from '../../../EditTechnicalLicense/utils';
import { formatDateDashYMDTimeHMS, formatSlashMDY } from '../../../utils/constants/formatters';

import './ADGMLicense.scss';

const ADGMLicense = (props: ADGMLicenseProps) => {
  const {
    setHasLicense,
    setADGMField,
    hasLicense,
    title,
    fileName,
    isAddMissingDetails,
  } = props;

  const beforeUpload = (license: RcFile) => {
    setADGMField({ field: 'aDGMLicenseUrl', data: license as Blob });

    return false;
  }

  useEffect(() => {
    setHasLicense({ data : true });
  }, [])

  return (
    <div className="adgm-license">
      <Input.Heading title={title} />

      <RenderIf condition={hasLicense}>
        <>
          <div
            className={classnames('adgm-license__fields', {
              'adgm-license__fields__add-missing-details': isAddMissingDetails,
            })}
          >
            <Input
              name="aDGMLicenseNo"
              label="ADGM License No."
              layout="vertical"
              required
              rules={[requiredValidation]}
            >
              <Input.InputField placeholder="Enter ADGM License No." />
            </Input>

            <Input
              name="legalADGMName"
              label="ADGM Legal Name"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation] : []}
            >
              <Input.InputField placeholder="Enter ADGM Legal Name" />
            </Input>

            <Input
              name="legalSignatoryName"
              label="ADGM Legal Signatory Name"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation] : []}
            >
              <Input.InputField placeholder="Enter ADGM Legal Signatory Name" />
            </Input>

            <Input
              name="legalSignatoryTitle"
              label="ADGM Legal Signatory Title"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation] : []}
            >
              <Input.InputField placeholder="Enter ADGM Legal Signatory Title" />
            </Input>

            <Input
              name="legalSignatoryEmail"
              label="ADGM Legal Signatory Email"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation, emailValidation] : []}
            >
              <Input.InputField placeholder="Enter ADGM Legal Signatory Email" />
            </Input>

            <div className="adgm-license__fields__column-inputs">
              <Input
                name="address"
                label="Registered WeWork Address"
                className="input__address"
                layout="vertical"
                required={isAddMissingDetails}
                rules={isAddMissingDetails ? [requiredValidation] : []}
              >
                <Input.InputField.TextArea
                  size="large"
                  rows={4}
                  placeholder="Enter Registered WeWork Address"
                />
              </Input>
            </div>

            <Input
              name="issueDate"
              label="ADGM Issue Date"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation] : []}
            >
              <Input.DatePicker
                format={formatSlashMDY}
                placeholder="Select ADGM Issue Date"
                onChange={(date) => setADGMField({
                  field: 'issueDate',
                  data: moment(date).format(formatDateDashYMDTimeHMS),
                })}
              />
            </Input>

            <Input
              name="expiryDate"
              label="ADGM Expiry Date"
              layout="vertical"
              required={isAddMissingDetails}
              rules={isAddMissingDetails ? [requiredValidation] : []}
            >
              <Input.DatePicker
                format={formatSlashMDY}
                placeholder="Select ADGM Expiry Date"
                onChange={(date) => setADGMField({
                  field: 'expiryDate',
                  data: moment(date).format(formatDateDashYMDTimeHMS),
                })}
              />
            </Input>
          </div>

          <Input
            name="documents"
            required={isAddMissingDetails}
            label="ADGM License .pdf"
            layout="vertical"
          >
            <Input.DraggerUpload
              defaultFileList={
                identity.isEmptyString(fileName) ? [] : [...getTechnicalLicenseFile(fileName)]
              }
              allowChange
              accept=".pdf"
              beforeUpload={beforeUpload}
              isRoundableButton
            />
          </Input>
        </>
      </RenderIf>
    </div>
  );
}

ADGMLicense.defaultProps = {
  viewType: 'missing_details',
  title:'Add ADGM License',
  isAddMissingDetails: false,
}

export default ADGMLicense;
